export default __webpack_public_path__ + "static/media/barcelona.68f6c3af.png";